import React from 'react';
import { ethnicityData } from './ethnicityData';
import DropdownListPage from '../../../molecules/dropdownListPage/DropdownListPage';
import appStrings from '../../../../../common/app_strings';
import { useAppState } from '../../../../../providers/app-state/app-state-provider';

const { wholeMe: { wholeMeEthnicityIntake } } = appStrings;

const ProfileIdentityIntakeEthnicityPage = ({
  paginationMeta,
  nextOnClick,
  prevOnClick,
  wholeMeClient,
  exitIconOnClickOverride,
}) => {
  const dataFetcher = wholeMeClient.fetchEthnicityState;
  const dataSaver = wholeMeClient.saveEthnicityState;
  const { platform } = useAppState();

  return (
    <DropdownListPage
      fields={ethnicityData}
      paginationMeta={paginationMeta}
      nextOnClick={nextOnClick}
      prevOnClick={prevOnClick}
      title={wholeMeEthnicityIntake.title}
      subtitle={wholeMeEthnicityIntake.subtitle}
      backgroundOverlay="/assets/overlays/two-circle-background-overlay.svg"
      categoryId="identity"
      questionId="ethnicity"
      dataFetcher={dataFetcher}
      dataSaver={dataSaver}
      mainImage="assets/icons/intake-pages/orange-circle-three-blue-lines.svg"
      titleStyleOverride={{
        subHeaderStyles: {
          padding: '0 40px 20px 40px',
        },
      }}
      exitIconOnClickOverride={exitIconOnClickOverride}
      mainImageOverrideStyles={{
        paddingRight: '7%',
        width: platform?.isNativePlatform ? 'calc(90% - 80px)' : 'calc(45% - 80px)',
      }}
      skipPersonalization
    />
  );
};

export default ProfileIdentityIntakeEthnicityPage;
